function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 16.93 16.93"
}, props), /*#__PURE__*/React.createElement("g", {
  color: "#000",
  fontFamily: "sans-serif",
  fontWeight: "400"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#dbe9ee",
  stroke: "rgba(0, 0, 0, 0.80 )",
  strokeWidth: ".75",
  d: "M8.47.53A7.94 7.94 0 00.53 8.47a7.94 7.94 0 007.94 7.93 7.94 7.94 0 007.93-7.93A7.94 7.94 0 008.48.53z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e86262",
  d: "M15.35 8.47h-2.12a4.76 4.76 0 01-.64 2.37.27.27 0 00.1.37l1.37.79a.27.27 0 00.36-.1 6.88 6.88 0 00.93-3.43z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6b6b",
  d: "M12.57 6.1c.41.7.66 1.5.66 2.37h2.12a6.8 6.8 0 00-.95-3.43z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffab12",
  d: "M11.9 2.53l-1.06 1.83a4.74 4.74 0 011.73 1.73l1.83-1.05a6.87 6.87 0 00-2.5-2.5z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6bf178",
  d: "M1.59 8.47a6.88 6.88 0 00.92 3.43.27.27 0 00.37.1l1.37-.8a.27.27 0 00.1-.36 4.76 4.76 0 01-.65-2.37z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62dc6e",
  d: "M2.54 5.04a6.8 6.8 0 00-.95 3.43H3.7c0-.87.25-1.68.66-2.38z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fde74c",
  d: "M6.1 4.36L5.04 2.53a6.87 6.87 0 00-2.5 2.51L4.35 6.1a4.74 4.74 0 011.73-1.73z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2d503",
  d: "M8.47 1.59a6.8 6.8 0 00-3.43.94L6.1 4.36a4.72 4.72 0 012.37-.66z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffbc42",
  d: "M10.84 4.36l1.05-1.83a6.8 6.8 0 00-3.42-.94V3.7c.87 0 1.67.25 2.37.66z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#33658a",
  d: "M12.28 4.29l-4.53 3.4 1.49 1.5 3.4-4.53a.27.27 0 00-.36-.37z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6b6b",
  d: "M8.47 7.14c-.73 0-1.33.6-1.33 1.33a1.33 1.33 0 001.33 1.32c.72 0 1.32-.6 1.32-1.32 0-.73-.6-1.33-1.32-1.33z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#33b9ef",
  d: "M5.56 11.9a.27.27 0 00-.27.27v1.59a.27.27 0 00.27.26h5.82a.27.27 0 00.26-.26v-1.59a.27.27 0 00-.26-.27z",
  overflow: "visible",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  }
}))));